module.exports = __webpack_public_path__ + "e783cc57aa0db47e1d87a457ead54fc9.svg";